import { useExtraData, useElasticData } from "../DataContext.js";
import { getFormattedDate } from '../helpers.js';
import { currency } from "../../helpers.mjs";

const InternalPanel = ({tabIndex, sel}) => {

    let { productData, product, distributorInfo } = useElasticData();
        
    let { _source, internalKeywordsData } = useExtraData();
    
    const name = `tab-${tabIndex}`;

    // Internal
    let _internal = [];
    
    _internal[0] = {
        "heading" : "Internal info",
        "rows" : {
            "ID" : product,
            "Enhanced" : _source.enhanced ? "Yes" : "No",
            "Release date" : (_source.release_date === null || _source.release_date == "0001-01-01T00:00:00Z") ? "Unknown" : getFormattedDate(_source.release_date, { year: 'numeric', month: 'numeric', day: 'numeric' }),
            "Pre-pub date" : _source.pre_pub_assessment_date === null ? "N/A" : getFormattedDate(_source.pre_pub_assessment_date, { year: 'numeric', month: 'numeric', day: 'numeric' }),
            "BIN" : _source.bin_location,
            "On order" : _source.peters_has_stock ? "Yes" : "No",
            "Stock" : _source.stock_level_display,
            "Stock control level" : _source.control_figure,
            "Reserved" : _source.reserved_level,
            "Last intake" : _source.date_last_intake && _source.date_last_intake != "0000-00-00" ? getFormattedDate(_source.date_last_intake, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
            "Report code" : _source.report_code === null ? "" : _source.report_code,
            "Distributor" : `${_source.distributor.title} (${_source.distributor.value})`,
            "Discount code" : _source.discount_code,
            "Expected discount" : _source.expected_discount,
            "Cost price" : `${currency(productData?.costPrice)} (Source: "${productData?.costPriceSource}")`,
            "GP £" : productData?.gp,
            "GP %" : productData?.gpp,
            "Embargo date" : _source.embargo_date && _source.embargo_date != "0000-00-00" ? getFormattedDate(_source.embargo_date, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
            "Record created" : _source.record_created && _source.record_created != "0000-00-00" ? getFormattedDate(_source.record_created, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
            "BDS/Nielsen import" : _source.bds_import_time &&_source.bds_import_time != "0000-00-00" ? getFormattedDate(_source.bds_import_time, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
            "Updated" : (_source.updated_at && _source.updated_at != "0000-00-00" && _source.updated_at != _source.record_created) ? getFormattedDate(_source.updated_at, { year: 'numeric', month: 'numeric', day: 'numeric' }) : "Unknown",
            // "BDS data source": productData.peSource,
            "Internal keyword": _source.internal_keywords && internalKeywordsData[_source.internal_keywords],
            "Librarian notes": _source.librarian_notes
        }
    };

    if(_source.best_year_group?.title != ""){
        _internal[0].rows["Best year group"] = _source.best_year_group.title;
    }

    const distributorTable = () => {

        let tableHead = "<thead><tr><th>Distributor</th><th>Qty</th><th>Disc</th><th>Firm?</th></tr></thead>"
        let tableRows = "";

        if(distributorInfo.length){
            distributorInfo.forEach((di, i) =>{
                tableRows += `<tr><td>${di.spName}</td><td>${di.dbdQtyHeld}</td><td>${di.dbdDiscount}</td><td>${di.dbdFirmSale === "1" ? "Y" : "N"}</td></tr>`;
            });
        }
    

        return `<table class="distributorTable">${tableHead}<tbody>${tableRows}</tbody></table>`;
    }   

    _internal[1] = {
        "heading" : "Distirbutor info",
        "rows" : {
            "" : distributorTable()
        }
    };

    const internalHeadings = _internal.map(x => x.heading);
    const internalRows = Object.values(_internal.map(x => x.rows));
    let internalHtml = "";

    internalRows.forEach((rows, i) => {
        let rowLabels = Object.keys(rows);
        let rowValues = Object.values(rows);
        let internalRowsHtml = "";
        
        rowLabels.forEach((label, j) => {
            if(rowValues[j] && rowValues[j] != "") {
                internalRowsHtml += `${label ? `<div class="half column"><strong>${label}</strong></div><div class="half column">${rowValues[j]}</div>` : `${rowValues[j]}`}`;
            }
        });
        if(i == 0){
            internalHtml += `<div class="half column"><h4>${internalHeadings[i]}</h4><div class="columns wrap">${internalRowsHtml}</div></div>`;
        } else{
            internalHtml += `<div class="half column">${internalRowsHtml}</div>`;
        }

    });

    return(
        <>
            <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
                <div className="columns wrap" dangerouslySetInnerHTML={{__html: internalHtml}} />
            </div>
        </>
    )
}

export default InternalPanel;